export default __webpack_public_path__ + "navigation-examples-predictive-caching-thumbnail-480-e24a74b96c2ab9cc07840323b2c18425.webp";